module.exports = __webpack_public_path__ + "img/yzm7.f912fc8e.png";